import React, { Component, createRef } from 'react';
import _ from 'lodash';
import Select from '../common/Select';
import { getErrorMessage, hasErrorInOption } from './formErrorHelper';

class StreamTDSScriptValues extends Component {
  constructor(props) {
    super(props);
    this._alertRefs = {
        [props.errorPath]: createRef(),
    };
  }
  getOptions = () => {
    const {settings, type} = this.props;
    return type && settings ? Object.keys(settings.values).map(v => ({
      value: settings.values[v].key,
      label: settings.values[v].value,
    })) : null;
  }
  optValueHasError = () => {
    const {errors, optKey, scrKey, errorPath} = this.props;
    return hasErrorInOption({
      errors,
      errorPath,
      optKey,
      scrKey,
    });
  }
  componentDidMount() {
    const {saveRef, errorPath, scrKey, optKey} = this.props;
    saveRef(true, errorPath, this._alertRefs[errorPath], scrKey, optKey);
  }
  handleMultipleChange = (selected) => {
    if(selected) {
      this.props.onChangeScriptOptionValue(
        selected.map(item => {
          if(item.value) {
            return item.value;
          }
        })
      );
    } else {
      this.props.onChangeScriptOptionValue([]);
    }
  }
  handleSingleChange = (selected) => {
    this.props.onChangeScriptOptionValue(selected.value);
  }
  renderValues = error => {
    const {
      settings,
      type,
      value,
      multiple,
    } = this.props;
    const options = this.getOptions();
    if(!type || !settings) {
      return null;
    }
    else if(multiple) {
      return (
        <Select
          className={error ? 'has-error' : ''}
          clearable={false}
          closeOnSelect={false}
          value={value}
          multi={multiple}
          onChange={this.handleMultipleChange}
          options={options}
        />
      );
    } else {
      return (
        <Select
          className={error ? 'has-error' : ''}
          clearable={false}
          value={value}
          onChange={this.handleSingleChange}
          options={options}
        />
      );
    }
  }

  render() {
    const {
      errorPath,
      scrKey,
      optKey,
    } = this.props;
    const optValueHasError = this.optValueHasError();
    return (
      <div
        className='stream-tds-script-values'
        ref={this._alertRefs[errorPath]}
        id={`${errorPath}${scrKey}_${optKey}`}
      >
        {this.renderValues(optValueHasError)}
        {optValueHasError && <small className="form-text">{getErrorMessage(errorPath)}</small>}
      </div>
    );
  }
}

export default StreamTDSScriptValues;